import { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import Pluralize from 'react-pluralize';
import { useSelector } from 'react-redux';
import Modal from '../../../Modal';
import CarItinerary from '../CarItinerary';
import CarsFilterBar from '../CarsFilterBar';
import CarsList from '../CarsList';
import CarsPagination from '../CarsPagination';
import CarsSorting from '../CarsSorting';

const ModalContent = ({
  tripId,
  selectedTab,
  doAddChangeCarBookedTrip,
  isModalOpen,
  onCloseModal,
  doShowAsModalOnly,
  onModalClose,
}) => {
  const trip = useSelector((store) => store.trip.selectedTrips[tripId]);
  const selectedCarsCount = useMemo(() => {
    if (trip && trip.rentalCarItineraries) {
      return Object.values(trip.rentalCarItineraries).length;
    }
    return 0;
  }, [trip]);

  return (
    <Modal open={isModalOpen || doShowAsModalOnly} onClose={onCloseModal}>
      <div className="px-8 grid grid-flow-col auto-cols-max gap-5 font-bold border-b-2">
        <a
          role="button"
          tabIndex="-1"
          className="text-theme border-b-2 border-theme py-4 w-24 text-center"
        >
          Car
        </a>
      </div>
      <div className="font-bold m-5">Filter by</div>
      <div className="m-5">
        <CarsFilterBar tripId={tripId} selectedTab={selectedTab} />
        {!doAddChangeCarBookedTrip && selectedCarsCount ? (
          <>
            <div className="mt-10 mb-5 font-bold">
              Selected <Pluralize singular="car" count={selectedCarsCount} showCount={false} />
            </div>
            {Object.entries(trip.rentalCarItineraries).map(([key, value]) => (
              <CarItinerary
                key={`${value.id}`}
                itinerary={value}
                tripId={tripId}
                onModalClose={onModalClose}
                selectedTab={key}
              />
            ))}
          </>
        ) : (
          ''
        )}
      </div>
      <div className="m-5 flex justify-between items-center">
        <CarsPagination tripId={tripId} selectedTab={selectedTab} />
        <CarsSorting tripId={tripId} selectedTab={selectedTab} />
      </div>
      <div className="my-5 mx-5">
        <CarsList
          onViewMoreClick={onCloseModal}
          isInsideModal
          tripId={tripId}
          onModalClose={onCloseModal}
          selectedTab={selectedTab}
        />
      </div>
      <div className="m-5">
        <CarsPagination tripId={tripId} selectedTab={selectedTab} />
      </div>
    </Modal>
  );
};

ModalContent.propTypes = {
  tripId: PropTypes.string.isRequired,
  selectedTab: PropTypes.number,
  doAddChangeCarBookedTrip: PropTypes.bool,
  isModalOpen: PropTypes.bool,
  onCloseModal: PropTypes.func,
  doShowAsModalOnly: PropTypes.bool,
  onModalClose: PropTypes.func,
};

ModalContent.defaultProps = {
  selectedTab: undefined,
  doAddChangeCarBookedTrip: undefined,
  isModalOpen: undefined,
  onCloseModal: undefined,
  doShowAsModalOnly: undefined,
  onModalClose: undefined,
};

export default memo(ModalContent);
